// src/components/atomic/ConnectionStatusDot/ConnectionStatusDot.tsx
import './ConnectionStatusDot.scss';

export interface ConnectionStatusDotProps {
  isConnected: boolean;
  relayCount: number;
  peerCount: number;
}

export function ConnectionStatusDot({ isConnected, relayCount, peerCount }: ConnectionStatusDotProps) {
  const statusClass = isConnected ? 'connected' : 'disconnected';
  const tooltipText = isConnected
    ? `Connected: ${relayCount} bootstrap node${relayCount !== 1 ? 's' : ''}, ${peerCount} peer${peerCount !== 1 ? 's' : ''}`
    : 'Not connected';

  return (
    <div className="connection-status-dot-container" title={tooltipText}>
      <span className={`connection-status-dot ${statusClass}`} />
    </div>
  );
}

export default ConnectionStatusDot;
